"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@components/Button"));
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
var SelectDropdown_1 = __importDefault(require("@components/SelectDropdown"));
var react_hook_form_1 = require("react-hook-form");
var validator_1 = __importDefault(require("@utils/validator"));
var pendingInvitesSlice_1 = require("@features/SettingsPage/state/pendingInvitesSlice");
var react_redux_1 = require("react-redux");
var _store_1 = require("@store");
function CreateInvite(props) {
    var _a, _b, _c;
    var roles = props.roles, domain = props.domain, showCaptcha = props.showCaptcha;
    var _d = (0, react_hook_form_1.useForm)(), register = _d.register, handleSubmit = _d.handleSubmit, control = _d.control, errors = _d.formState.errors, reset = _d.reset, getValues = _d.getValues;
    var creatingInvite = (0, react_redux_1.useSelector)(pendingInvitesSlice_1.loadingSelector);
    var dispatch = (0, _store_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)(['settings']).t;
    var recaptchaRef = (0, react_1.useRef)(null);
    var onSubmit = function (data) {
        var _a;
        dispatch((0, pendingInvitesSlice_1.createInvite)(domain, data));
        reset(__assign(__assign({}, getValues()), { captchaToken: '', email: '', roleId: undefined }));
        (_a = recaptchaRef === null || recaptchaRef === void 0 ? void 0 : recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
    };
    return (react_1.default.createElement("form", { className: "create-invite" },
        react_1.default.createElement("div", { className: "create-invite__content" },
            react_1.default.createElement("input", __assign({ className: (0, clsx_1.default)('create-invite__input', errors.email && 'eva-input--invalid'), placeholder: (_a = t('settings:TEAM_MEMBER.CREATE_INVITE.INPUT_PLACEHOLDER')) !== null && _a !== void 0 ? _a : '' }, register('email', { required: true, validate: function (val) { return validator_1.default.isEmail(val); } }))),
            react_1.default.createElement(react_hook_form_1.Controller, { name: "roleId", control: control, rules: { required: true }, render: function (_a) {
                    var field = _a.field;
                    return (react_1.default.createElement(SelectDropdown_1.default, { hasError: !!errors.roleId, items: roles.map(function (role) { return ({ id: "".concat(role.id), text: role.role }); }), selectedItemId: "".concat(field.value), placeholderText: "- ".concat(t('settings:TEAM_MEMBER.CREATE_INVITE.BUTTON_PLACEHOLDER'), " -"), onItemSelected: function (id) { return field.onChange(parseInt(id)); } }));
                } }),
            react_1.default.createElement(Button_1.default, { disabled: creatingInvite, text: t('settings:TEAM_MEMBER.CREATE_INVITE.INVITE_BUTTON_TEXT'), onClick: handleSubmit(onSubmit), className: "btn" })),
        react_1.default.createElement("div", { className: "create-invite__input-error" },
            ((_b = errors.email) === null || _b === void 0 ? void 0 : _b.type) === 'required' ? t('settings:TEAM_MEMBER.CREATE_INVITE.ERROR.EMPTY_EMAIL') : '',
            ((_c = errors.email) === null || _c === void 0 ? void 0 : _c.type) === 'validate' ? t('settings:TEAM_MEMBER.CREATE_INVITE.ERROR.INVALID_EMAIL') : ''),
        showCaptcha && (react_1.default.createElement(react_hook_form_1.Controller, { name: "captchaToken", control: control, rules: { required: true }, render: function (_a) {
                var field = _a.field;
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_google_recaptcha_1.default, { ref: recaptchaRef, sitekey: RECAPTCHA_KEY, onChange: function (val) { return field.onChange(val); } }),
                    react_1.default.createElement("div", { className: "setting__error" }, errors.captchaToken ? t('settings:TEAM_MEMBER.CREATE_INVITE.CAPTCHA_ERROR') : '')));
            } }))));
}
exports.default = CreateInvite;
